var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 6.66667C7.33203 7.37391 7.61298 8.05219 8.11308 8.55229C8.61318 9.05238 9.29145 9.33333 9.9987 9.33333C10.7059 9.33333 11.3842 9.05238 11.8843 8.55229C12.3844 8.05219 12.6654 7.37391 12.6654 6.66667C12.6654 5.95942 12.3844 5.28115 11.8843 4.78105C11.3842 4.28095 10.7059 4 9.9987 4C9.29145 4 8.61318 4.28095 8.11308 4.78105C7.61298 5.28115 7.33203 5.95942 7.33203 6.66667Z",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.668 14.6719H16.668",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.668 12.6719V16.6719",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16V14.6667C6 13.9594 6.28095 13.2811 6.78105 12.781C7.28115 12.281 7.95942 12 8.66667 12H11.3333",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMember);
export default __webpack_public_path__ + "static/media/addMember.aa949d94ac48793bc12a915e9710d493.svg";
export { ForwardRef as ReactComponent };